import * as React from 'react'

const NxtWaveIcon = (props) => (
  <svg
    width={props.width}
    height={props.height}
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M66.352 22.745h-7.961a3.25 3.25 0 0 0-3.25 3.258v10.722a3.254 3.254 0 0 0 3.25 3.258h7.961a3.25 3.25 0 0 0 3.25-3.258v-10.73a3.243 3.243 0 0 0-3.25-3.25Zm-.233 5.34h-4.982v1.92h4.74v2.323h-4.74v2.308h4.982v2.3h-7.487V25.784h7.494v2.301h-.007ZM32.452 22.745H29.61l-7.166 17.23h4.23l1.11-2.914h6.478l1.11 2.914h4.23l-7.151-17.23Zm-3.316 10.751 1.906-4.966 1.877 4.966h-3.783ZM53.556 22.745l-6.925 17.23H43.79l-6.946-17.23h4.28l4.097 10.78 4.032-10.78h4.303ZM23.063 25.93 19.31 38.17a2.555 2.555 0 0 1-2.447 1.804h-.022a2.553 2.553 0 0 1-2.425-1.753l-2.133-6.42c-.197-.599-1.044-.599-1.241 0L8.886 38.23a2.553 2.553 0 0 1-2.425 1.745 2.562 2.562 0 0 1-2.447-1.811L.625 29.15h2.608c.854 0 1.614.562 1.855 1.387l.548 2.133c.365 1.242 2.067 1.38 2.622.212l1.234-4.733a2.27 2.27 0 0 1 2.162-1.563 2.27 2.27 0 0 1 2.155 1.556l1.27 4.77c.57 1.153 2.265 1.015 2.623-.227l1.68-7.735-1.84-.49 5.127-4.163 2.38 6.157-1.986-.525Z"
      fill="#002A4B"
    />
    <path
      d="M14.963 0v17.23h-3.98L4.502 6.676V17.23H.625V0h3.959l6.5 10.503V0h3.879ZM28.58 0l-3.228 5.244.036.059.015.022.401.657 1.103 1.68.665 1L33.203 0H28.58ZM27.57 8.685l-1.789 2.79v-.007l-.27.43-.183.286 3.229 5.047h4.645L27.57 8.685ZM39.04 3.557H34V0h13.987v3.557H42.97V17.23h-3.93V3.557ZM27.57 8.663v.021l.008-.014-.008-.007Z"
      fill="#006EC6"
    />
    <path
      d="m25.468 7.662-1.11-1.68-.402-.657-.014-.022L20.677 0H16.03l4.638 7.143.994 1.534-1.147 1.746-4.463 6.807h4.653l1.059-1.68.16-.255 2.14-3.397.271-.43.007.007 1.79-2.805-.665-1.008Z"
      fill="#002A4B"
    />
    <path
      opacity={0.25}
      d="m28.58 0-3.228 5.245.036.058.015.022.401.657 1.103 1.68.665 1L33.203 0H28.58Z"
      fill="url(#a)"
    />
    <path
      opacity={0.25}
      d="m27.57 8.685-1.789 2.79v-.007l-.27.43-.183.286 3.229 5.047h4.645L27.57 8.685Z"
      fill="url(#b)"
    />
    <path
      opacity={0.25}
      d="m19.384 24.95 3.682.98-1.373 4.484-3.295-.92.986-4.543Z"
      fill="url(#c)"
    />
    <path
      opacity={0.25}
      d="M42.969 3.558h-3.93v4.755h3.93V3.558Z"
      fill="url(#d)"
    />
    <path
      opacity={0.25}
      d="m11.086 10.504 3.878 6.325V4.609l-3.878 1.395v4.5Z"
      fill="url(#e)"
    />
    <path
      opacity={0.25}
      d="M4.503 6.756.625.431v12.227l3.878-1.395V6.756Z"
      fill="url(#f)"
    />
    <path
      opacity={0.25}
      d="m27.773 37.054 1.359-3.557h3.784l1.336 3.557h-6.479Z"
      fill="url(#g)"
    />
    <path
      opacity={0.25}
      d="m45.227 33.526 1.95 5.113 3.506-8.736-3.017-2.892-2.44 6.515Z"
      fill="url(#h)"
    />
    <path
      d="M73.61 35.813v-.884h4.164v.884h-1.552V40h-1.06v-4.187h-1.553ZM78.46 34.929h1.322l1.397 3.407h.06l1.396-3.407h1.322v5.07h-1.04v-3.3h-.042l-1.312 3.276h-.709l-1.312-3.288H79.5V40h-1.04v-5.071Z"
      fill="#002A4B"
    />
    <defs>
      <linearGradient
        id="a"
        x1={25.664}
        y1={6.22}
        x2={33.365}
        y2={0.204}
        gradientUnits="userSpaceOnUse"
      >
        <stop />
        <stop offset={0.07} stopOpacity={0.93} />
        <stop offset={1} stopOpacity={0} />
      </linearGradient>
      <linearGradient
        id="b"
        x1={33.185}
        y1={17.253}
        x2={25.671}
        y2={10.948}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopOpacity={0} />
        <stop offset={0.93} stopOpacity={0.93} />
        <stop offset={1} />
      </linearGradient>
      <linearGradient
        id="c"
        x1={20.014}
        y1={29.965}
        x2={21.228}
        y2={25.436}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopOpacity={0} />
        <stop offset={1} />
      </linearGradient>
      <linearGradient
        id="d"
        x1={41.004}
        y1={8.314}
        x2={41.004}
        y2={3.56}
        gradientUnits="userSpaceOnUse"
      >
        <stop stopOpacity={0} />
        <stop offset={0.93} stopOpacity={0.93} />
        <stop offset={1} />
      </linearGradient>
      <linearGradient
        id="e"
        x1={13.023}
        y1={16.831}
        x2={13.023}
        y2={4.608}
        gradientUnits="userSpaceOnUse"
      >
        <stop />
        <stop offset={0.07} stopOpacity={0.93} />
        <stop offset={1} stopOpacity={0} />
      </linearGradient>
      <linearGradient
        id="f"
        x1={2.566}
        y1={0.432}
        x2={2.566}
        y2={12.655}
        gradientUnits="userSpaceOnUse"
      >
        <stop />
        <stop offset={0.07} stopOpacity={0.93} />
        <stop offset={1} stopOpacity={0} />
      </linearGradient>
      <linearGradient
        id="g"
        x1={27.775}
        y1={35.277}
        x2={34.251}
        y2={35.277}
        gradientUnits="userSpaceOnUse"
      >
        <stop />
        <stop offset={0.07} stopOpacity={0.93} />
        <stop offset={1} stopOpacity={0} />
      </linearGradient>
      <linearGradient
        id="h"
        x1={45.121}
        y1={33.798}
        x2={51.237}
        y2={31.202}
        gradientUnits="userSpaceOnUse"
      >
        <stop />
        <stop offset={0.07} stopOpacity={0.93} />
        <stop offset={1} stopOpacity={0} />
      </linearGradient>
    </defs>
  </svg>
)

NxtWaveIcon.defaultProps = {
  width: 85,
  height: 40,
  fill: 'none'
}

export { NxtWaveIcon }
